<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="data"
      dense
      :server-items-length="total"
      :options.sync="options"
      :footer-props="{
        'items-per-page-options': [25, 50],
        'items-per-page-text': 'Mostrar',
      }"
      :loading="loading"
      loading-text="Carregando..."
    >
      <template v-slot:[`item.user_id`]="{ item }">
        <small>{{
          professionalClassCouncilValue(getUserById(item.user_id))
        }}</small>
      </template>
      <template v-slot:[`item.when`]="{ item }">
        {{ formatDate(item.when) }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        {{ handleAction(item.action) }}
      </template>
      <template v-slot:[`item.enabled`]="{ item }">
        {{ item.checked ? "SIM" : "NÃO" }}
      </template>
    </v-data-table>
    <errors-messages :errors="errors" />
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import { formatDate, professionalClassCouncilValue } from "../../lib/format";

export default {
  name: "Logs",

  components: {
    ErrorsMessages,
  },

  data() {
    return {
      options: {
        page: 1,
      },

      headers: [
        { text: "Responsável", value: "user_id", sortable: false },
        { text: "Ocorrência", value: "when", sortable: false },
        { text: "Ação", value: "action", sortable: false },
        { text: "Habilitou?", value: "enabled", sortable: false },
      ],

      data: [],
      total: 0,

      loading: false,
      errors: [],
    };
  },

  props: {
    resident_id: [String, Number],
    users: [Array],
    item: { type: [Boolean, Object] },
  },

  watch: {
    options() {
      this.paginate();
    },
  },

  created() {
    this.paginate();
  },

  methods: {
    formatDate,
    professionalClassCouncilValue,

    handleAction(action) {
      // "READ" | "WRITE" | "EDIT" | "REMOVE"
      return (
        {
          READ: "VER",
          WRITE: "CRIAR",
          EDIT: "MODIFICAR",
          REMOVE: "REMOVER",
        }[action] || "Não identificado"
      );
    },

    getUserById(id) {
      for (let user of this.users) {
        if (user.id == id) {
          return {
            id: user.professional_class_council_id,
            name: user.name,
            value: user.professional_class_council_value,
            cpf: user.cpf,
            office: user.office,
          };
        }
      }

      return {
        id: null,
        name: "DEMO",
        value: null,
        cpf: null,
        office: null,
      };
    },

    async paginate() {
      try {
        let { item, options } = this;

        let { id, profile_id } = item;

        let { page, itemsPerPage } = options;

        let params = { permission_id: id, profile_id, page, itemsPerPage };

        const response = await api.get("/rest-home/permission/history", {
          params,
        });

        const { data, total } = response.data;

        this.data = data;
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
